import { post, patch, get } from "@/utils/request";
import { downLoadByUrl } from "@/utils/utils";

const dataPacketPath = "/api/dots-collector-factory/data-packet"

export function getPacketList(data) {
  return post(dataPacketPath + "/page", data);
}

export function exportPacketList(data) {
  return downLoadByUrl(
    `${dataPacketPath}/:export`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "post",
    data
  );
}

export function postDataPacket(data) {
  return post(dataPacketPath, data);
}

export function patchDataPacket(id, data) {
  return patch(dataPacketPath + "/" + id, data);
}

export function patchPacketFile(packetId, dataId, data) {
  return patch(`${dataPacketPath}/${packetId}/data/${dataId}`, data);
}

export function renamePacketFile(packetId, dataId, name) {
  return patch(`${dataPacketPath}/${packetId}/data/${dataId}/name`, { name });
}

export function getPacketFileList(packetId, data) {
  return post(`${dataPacketPath}/${packetId}/data/page`, data);
}

export function abortAllPackets() {
  return post(`${dataPacketPath}/update-status/aborted`);
}

export function getGroupTree(packetId) {
  return get(`/api/dots-collector-factory/data-group/tree?packetId=${packetId}`).then(res => {
    if (res.code === 0 && res.data) {
      res.data = [res.data]
    }
    return res
  });
}

export function addPacketData(data) {
  return post(`${dataPacketPath}/add`, data);
}

export function resumePacketData(packetId, files) {
  return post(`${dataPacketPath}/${packetId}/resume`, { files });
}

export function getPacketDetail(id) {
  return get(`${dataPacketPath}/${id}`);
}

export function cleanDataPacket(id) {
  return post(`${dataPacketPath}/${id}/clean`, {});
}

export function searchPacketData(data) {
  return post(`${dataPacketPath}/data/search`, data);
}
